import axiosConfig from "./axiosConfig";
import { GlobalStateRecord } from "./getGlobalState";

export interface CreateGlobalStateRequest {
  type: string;
  name: string;
  value: string;
}

const postGlobalState = async (
  authToken: string,
  body: CreateGlobalStateRequest
): Promise<{ globalState: GlobalStateRecord }> => {
  const { data } = await axiosConfig.post("/global-state", body, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default postGlobalState;
